export default __webpack_public_path__ + "static/media/12_croco.e3bf027f.jpg";